import { ClimaticPeril } from 'src/app/api/model/climaticPerilVm';

export type ClimaticState = {
  isStreetNumberPrecise: boolean | null;
  ClimaticPeril: ClimaticPeril[];
};

export const initialClimaticState: ClimaticState = {
  isStreetNumberPrecise: null,
  ClimaticPeril: [],
};
